<template>
  <div class="component-page-container border-top border-neutral-100">
    <div class="container-xxl" :class="{ 'd-lg-flex': aside }">
      <aside v-if="aside" class="pt-8 pr-lg-5">
        <slot name="aside" />
      </aside>
      <section class="py-8" :class="{ 'pl-lg-6 flex-fill': aside }">
        <slot />
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    aside: Boolean
  }
};
</script>
<style lang="scss" scoped>
.component-page-container {
  background: var(--Surface-Solid-16, #fafbfc);

  aside {
    @media screen and (min-width: 992px) {
      border-right: var(--1-2, 1px) solid var(--Semantic-Neutral-100, #d7d7d7);
    }
  }
}
</style>
